import Header from '../components/Header';
import Footer from '../components/Footer';
import FadeInSection from '../components/FadeInSection';
import { Link } from 'react-router-dom';
import React, { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import TheApp from '../components/TheApp';
import { Helmet } from "react-helmet-async";





const outfitsData = [
  {
    id: 1,
    image: '../../img/home-f-3.webp',
    hotspots: [
      {
        id: 'h1',
        top: '25%',
        left: '45%',
        title: "Denim Jacket",
        brand: "Levi's",
        price: '$110',
        img: 'https://images.unsplash.com/photo-1509631179647-0177331693ae?auto=format&fit=crop&w=700&q=80'
      },
    
    ]
  },
  {
    id: 2,
    
   
    image: '../../img/home-f-2.webp',
    hotspots: [
      {
        id: 'h3',
        top: '30%',
        left: '50%',
        title: 'Linen Shirt',
        brand: 'Ralph Lauren',
        price: '$145',
        img: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?auto=format&fit=crop&w=700&q=80'
      }
    ]
  },
  {
    id: 3,
   
   
    image: '../../img/home-f-1.webp',
    hotspots: [
      {
        id: 'h4',
        top: '40%',
        left: '40%',
        title: 'Leather Trench',
        brand: 'Mango',
        price: '$250',
        img: 'https://images.unsplash.com/photo-1517841905240-472988babdf9?auto=format&fit=crop&w=700&q=80'
      }
    ]
  }
];


const outfitItems = [
    {
      id: 1,
      // category: "TOP",
      name: "Co ord set- brand label unlocked ",
      // brand: "Studio Minimal",
      price: "₹. 4650/-",
      img: "https://images.unsplash.com/photo-1598032895397-b9472444bf93?auto=format&fit=crop&q=80&w=200"
    },
    {
      id: 2,
      
      name: "Flats- brand stelway",
      // brand: "Atelier Co.",
      price: "₹. 1499/-",
      img: "https://images.unsplash.com/photo-1594633312681-425c7b97ccd1?auto=format&fit=crop&q=80&w=200"
    },
    {
      id: 3,
      
      name: "Earrings- brand dramebaaz India ",
      // brand: "Footwear Lab",
      price: "₹. 550/-",
      img: "https://images.unsplash.com/photo-1543163521-1bf539c55dd2?auto=format&fit=crop&q=80&w=200"
    },
    {
      id: 4,
     
      name: "Bag- brand imars fashion",
      // brand: "Craft & Thread",
      price: "₹. 1200/-",
      img: "https://images.unsplash.com/photo-1624222247344-550fb60583dc?auto=format&fit=crop&q=80&w=200"
    }
  ];

export default function Home() {
   const [isChecked, setIsChecked] = useState(true);

// const [selectedProduct, setSelectedProduct] = useState(null);
  const [isWishlisted, setIsWishlisted] = useState(false);


const [selectedProduct, setSelectedProduct] = useState(null);


  // Quick view function callback handler



  const openQuickView = (product) => {
    setSelectedProduct(product);
    setIsWishlisted(false);
  };

  const closeModal = () => {
    setSelectedProduct(null);
  };

  const scrollToShop = () => {
    const shopElement = document.getElementById('shopTheLook');
    if (shopElement) {
      shopElement.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const toggleWishlist = () => {
    setIsWishlisted(!isWishlisted);
    alert(
      !isWishlisted
        ? 'Saved to your Wearly Wishlist!'
        : 'Removed from your Wishlist!'
    );
  };


  return (
    <>

      <Helmet>
        <title>OutfitFind | Discover Fashion, Outfits & Style </title>
       <meta
        name="description"
        content="Discover trending fashion, stylish outfits, and must-have looks on OutfitFind. Find your style and shop your favorite fashion online."
      />
            </Helmet>
      <Header />
      <main>
        {/* Hero Section */}
        <section id="home" className="hero-section">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-6">
                <div className="hero-eyebrow">A NEW WAY TO DISCOVER FASHION</div>
                <h1 className="hero-title">
                  Find the whole look,<span className="italic"> not just </span>
                  the pieces.
                </h1>
                <p className="hero-subtitle">
                Professionally styled outfits from Homegrown fashion brands, you'll want to discover.
                </p>
                <div className="hero-buttons">
                  <Link to="/discover" className="btn-peach"><span>  EXPLORE OUTFITS</span></Link>
                  <Link to="#" className="btn-outline-peach"> APP COMING SOON</Link>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="hero-image-wrapper">
                     

                        <img src="../../img/home-hero.webp" className="img-fluid hero-image" alt="Hero Visual" />

                     
                    </div>
              </div>
            </div>
          </div>
        </section>

 

        {/* Categories */}
        <section className="categories-section">
          <div className="container">
            <div className="text-center">
             
              <h2 className="section-title">One look. <span className="italic">Every piece. </span></h2>
             
            </div>
           <div className="category-grid">
          <FadeInSection className="category-card">
            <span className="category-number">- 01</span>
            <div className="category-icon">
              <i className="bi bi-person-standing-dress"></i>
            </div>
            <h3 className="category-title">Discover complete outfits</h3>
            <p className="category-desc">
              Browse professionally styled looks for different occasions, moods and aesthetics.
            </p>
          </FadeInSection>

          <FadeInSection className="category-card">
            <span className="category-number">- 02</span>
            <div className="category-icon">
              <i className="bi bi-handbag"></i>
            </div>
            <h3 className="category-title">Explore every piece</h3>
            <p className="category-desc">
              See the clothing, footwear and accessories that make up each look.
            </p>
          </FadeInSection>

          <FadeInSection className="category-card">
            <span className="category-number">- 03</span>
            <div className="category-icon">
              <i className="bi bi-bag-heart"></i>
            </div>
            <h3 className="category-title">Shop from the brand</h3>
            <p className="category-desc">
              Explore and shop directly from the brand, all within OutfitFind.
            </p>
          </FadeInSection>
        </div>
          </div>
        </section>




<section className="curiosity-section" id="curiosity">
      <div className="container">
        {/* Header */}
        <div className="text-center mb-5">
        
          <h2 className="display-5 fw-bold text-white">ONE LOOK. EVERY DETAIL.</h2>
         
        </div>

        {/* Carousel */}
        <Swiper
          modules={[Autoplay, Pagination]}
          spaceBetween={24}
          slidesPerView={1}
          loop={true}
          autoplay={{ delay: 4500, disableOnInteraction: false }}
          pagination={{ clickable: true }}
          breakpoints={{
            768: { slidesPerView: 2 },
            1200: { slidesPerView: 3 }
          }}
          className="curiosity-carousel pb-5"
        >
          {outfitsData.map((outfit) => (
            <SwiperSlide key={outfit.id}>
              <div className="hotspot-card">
                <img src={outfit.image} alt={outfit.creator} />

               

                <div className="hotspot-overlay">
                  <h5 className="mb-0 text-white">{outfit.creator}</h5>
                 
                  <button
                    className="btn btn-sm btn-peach mt-2 w-100"
                    onClick={scrollToShop}
                  >
                    Explore Outfit
                  </button>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

    
    </section>



<section className="shop-the-look-section" id="shopTheLook">
      <div className="container">
        
        {/* App-Focused Section Header */}
        <div className="text-center mb-5">
          <span className="app-section-tag">OUTFIT BREAKDOWN</span>
          <h2 className="app-section-title mt-1">
            THE COMPLETE LOOK, <span>ALL IN ONE PLACE.</span>
          </h2>
          <p className="app-section-subtitle">
            See how OutfitFind tags every piece, lets you preview the full look, and seamlessly shop the complete outfit.
          </p>
        </div>

        {/* Main Side-by-Side Wrapper */}
        <div className="shop-look-container">
          <div className="row align-items-center justify-content-center g-5">
            
            {/* Left Side: Styled Complete Look Showcase */}
            <div className="col-lg-6">
              <div className="styled-look-card">
                <div className="styled-image-wrapper">
                  <img
                    src="../../img/home1.jpeg"
                    className="img-fluid w-100 styled-look-img"
                    alt="The Complete Styled Look"
                  />
                  <div className="look-badge-overlay">
                    

                    <span className="look-number-tag">Work fit</span>
                    <h4 className="look-title">Work fit for women</h4>
                    <p className="look-stylist mb-0">Under Rs.6,000/-</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Side: OutfitFind Mobile App Interface Display */}
            <div className="col-lg-5">
              <div className="app-frame-wrapper">
                <div className="mobile-phone-frame">
                  
                  {/* Phone Header Status Bar Mockup */}
                  <div className="phone-header">
                    <span className="app-logo-text">OutFitFind</span>
                    
                  </div>

                  {/* App Cart / Breakdown Header */}
                  <div className="app-cart-header">
                    <i className="bi bi-arrow-left"></i>
                    <span className="app-cart-title">Outfit Cart (4 Items)</span>
                    <i className="bi bi-bag"></i>
                  </div>

                  {/* App Screen Content: Pieces Breakdown */}
                  <div className="app-cart-scroll-list">
                    {outfitItems.map((item) => (
                      <div key={item.id} className="app-cart-item">
                                      
                                      {/* <img src={item.img} alt={item.name} className="app-item-img" /> */}

                      <div className="form-check custom-checkbox me-2" >
                          <input
                            className="form-check-input"
                            type="checkbox"
                            checked={isChecked}
                            onChange={(e) => setIsChecked(e.target.checked)}
                            id={`check-${item.id}`}
                          />
                          <label className="form-check-label" htmlFor={`check-${item.id}`}></label>
                        </div>
                        <div className="app-item-details">
                          <span className="app-item-category">{item.category}</span>
                          <h6 className="app-item-name">{item.name}</h6>
                          <small className="app-item-brand">{item.brand}</small>
                        </div>
                        <span className="app-item-price">{item.price}</span>
                      </div>
                    ))}
                  </div>

                  {/* App Footer Action CTA */}
                  <div className="app-cart-footer">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <span className="app-total-label">Total Bundle</span>
                      <span className="app-total-price">₹. 7,899/-</span>
                    </div>
                    <button className="btn-app-checkout">
                      GET LOOK IN OUTFITFIND APP
                    </button>
                  </div>

                </div>
              </div>
            </div>

          </div>
        </div>

      </div>
    </section>

        {/* Feature Section */}
    <section className="why-outfitfind-section">
      <div className="container">
        
        {/* Section Heading */}
        <div className="text-center mb-5">
          <span className="why-tag">THE DIFFERENCE</span>
          <h2 className="why-title mt-2">
            WHY <span>OUTFITFIND</span>
          </h2>
        </div>

        {/* Side-by-Side Visual Comparison Grid */}
        <div className="row g-4 align-items-stretch justify-content-center">
          
          {/* Column 1: The Usual Way */}
          <div className="col-lg-5 col-md-6">
            <div className="comparison-card usual-way">
              <div className="card-header-badge">
                <i className="bi bi-x-circle"></i> THE USUAL WAY
              </div>

              <div className="visual-step-flow">
                <div className="step-node">
                  <div className="step-icon"><i className="bi bi-search"></i></div>
                  <p className="step-text">Search for a top</p>
                </div>

                <div className="flow-arrow"><i className="bi bi-arrow-down"></i></div>

                <div className="step-node">
                  <div className="step-icon"><i className="bi bi-search"></i></div>
                  <p className="step-text">Find bottoms</p>
                </div>

                <div className="flow-arrow"><i className="bi bi-arrow-down"></i></div>

                <div className="step-node">
                  <div className="step-icon"><i className="bi bi-search"></i></div>
                  <p className="step-text">Find shoes</p>
                </div>

                <div className="flow-arrow"><i className="bi bi-arrow-down"></i></div>

                <div className="step-node">
                  <div className="step-icon"><i className="bi bi-plus-circle"></i></div>
                  <p className="step-text">Add accessories</p>
                </div>

                <div className="flow-arrow"><i className="bi bi-arrow-down"></i></div>

                <div className="step-node final-node">
                  <div className="step-icon"><i className="bi bi-question-circle"></i></div>
                  <p className="step-text">Try to make everything work together</p>
                </div>
              </div>
            </div>
          </div>

          {/* Column 2: With OutfitFind */}
          <div className="col-lg-5 col-md-6">
            <div className="comparison-card outfitfind-way">
              <div className="card-header-badge">
                <i className="bi bi-check-circle-fill"></i> WITH OUTFITFIND
              </div>

              <div className="visual-step-flow">
                <div className="step-node">
                  <div className="step-icon"><i className="bi bi-stars"></i></div>
                  <p className="step-text">Start with a styled complete look</p>
                </div>

                <div className="flow-arrow"><i className="bi bi-arrow-down"></i></div>

                <div className="step-node">
                  <div className="step-icon"><i className="bi bi-layers"></i></div>
                  <p className="step-text">Explore every piece</p>
                </div>

                <div className="flow-arrow"><i className="bi bi-arrow-down"></i></div>

                <div className="step-node final-node">
                  <div className="step-icon"><i className="bi bi-bag-check-fill"></i></div>
                  <p className="step-text">Shop what you like, all in one place</p>
                </div>
              </div>
            </div>
          </div>

        </div>

      </div>
    </section>


   <TheApp />


        
      </main>
      <Footer />
    </> 
  );
}